import React from 'react';
import styled from 'styled-components';
import { graphql } from 'gatsby';

import BlogIndexPage from '../components/blog/blog-index-page';
import Layout from '../components/layout';
import SEO from '../components/seo';

const BlogCategoryContainer = styled.div``;

const BlogCategory = ({ data }) => {
    let category = data.category.edges[0] && data.category.edges[0].node;

    return (
        <Layout>
            <SEO title={category.name} />
            <BlogCategoryContainer>
                <BlogIndexPage category={category} />
            </BlogCategoryContainer>
        </Layout>
    );
};

export default BlogCategory;

export const query = graphql`
    query($slug: String!) {
        category: allWpTermNode(filter: { slug: { eq: $slug } }) {
            edges {
                node {
                    name
                    slug
                }
            }
        }
    }
`;
